module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn custom-classes-transition",
      "leave-active-class": "animated fadeOut custom-classes-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.layoutShow),
      expression: "layoutShow"
    }],
    staticClass: "plekan-modal"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn custom-classes-transition-child",
      "leave-active-class": "animated  fadeOut custom-classes-transition-child"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bodyShow),
      expression: "bodyShow"
    }],
    staticClass: "plekan-modal-arena-layout"
  }, [_c('div', {
    staticClass: "plekan-modal-arena"
  }, [_c('a', {
    staticClass: "plekan-modal-close",
    on: {
      "click": function($event) {
        _vm.makeBroadcast()
      }
    }
  }), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("body"), _vm._v(" "), _vm._t("footer")], 2)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc0df33e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 120
// module chunks = 0